import React from "react"
import Markdown from "markdown-to-jsx"
import { elements, components } from "../components/views/DefaultMarkdown"

const CarrotMarkdown = ({ source, styleOverrides = {} }) => (
  <Markdown
    options={{
      overrides: { ...elements, ...components, ...styleOverrides },
      forceBlock: true
    }}
  >
    {source}
  </Markdown>
)
export default CarrotMarkdown
